import * as R from "ramda";
import { DETAIL } from "../actions";

const defaultState = {
  transfer: null,
  proposals: [],
  clientItems: [],
  manualManagement: [],
  multipleClients: [],
  selectedProposal: 0,
  modified: false,
  loading: false,
  error: false
};
const majorAccountMapper = x => {
  return {
    accountingKey: "",
    recArea: "",
    amount: x.amount,
    customer: x.majorAccount,
    society: x.society,
    division: x.division,
    observaciones: x.observaciones || "",
    ceco: x.ceco || ""
  };
};

const setLoading = state => ({ ...state, loading: true, error: false });
const getProposalsSuccess = (state, action) => {
  const proposals = action.payload;
  const terceros = proposals[0] && proposals[0].paymentsClient ? proposals[0].paymentsClient : [];
  const majorAccount = proposals[0] && proposals[0].paymentsCount ? proposals[0].paymentsCount : [];
  return {
    ...state,
    loading: false,
    error: false,
    proposals,
    manualManagement: [...terceros, ...majorAccount.map(majorAccountMapper)]
  };
};

const setErrors = state => ({ ...state, loading: false, error: true });
const getItemsSuccess = (state, action) => {
  const { selectedProposal, proposals } = state;
  const isManual = proposals[selectedProposal].user === "MANUAL";
  const terceros =
    proposals[selectedProposal] && proposals[selectedProposal].paymentsClient
      ? proposals[selectedProposal].paymentsClient
      : [];
  const majorAccount =
    proposals[selectedProposal] && proposals[selectedProposal].paymentsCount
      ? proposals[selectedProposal].paymentsCount
      : [];
  return {
    ...state,
    loading: false,
    error: false,
    clientItems: action.payload,
    multipleClients: isManual ? state.multipleClients : [],
    manualManagement: [...terceros, ...majorAccount.map(majorAccountMapper)]
  };
};
const searchTransferSuccess = (state, action) => ({
  ...state,
  loading: false,
  error: false,
  modified: false,
  manualManagement: [],
  clientItems: [],
  multipleClients: [],
  transfer: action.payload
});

const addTransfesrToProposals = (state, { payload }) => {
  const payloadCopy = { ...payload };
  const existing = state.multipleClients.find(x => x.tercero === payload.tercero);
  if (existing) {
    payloadCopy.clientItems = [...existing.clientItems, ...payloadCopy.clientItems];
    payloadCopy.manualManagement = [...existing.manualManagement, ...payloadCopy.manualManagement];
  }
  return {
    ...state,
    clientItems: state.clientItems.map(x => ({ ...x, selected: false })),
    multipleClients: [
      ...state.multipleClients.filter(x => x.tercero !== payload.tercero),
      payloadCopy
    ]
  };
};

const removeTransfesrToProposals = (state, { payload }) => {
  const { manualManagement, clientItems } = payload;
  return {
    ...state,
    multipleClients: [
      ...state.multipleClients
        .map(item => ({
          ...item,
          manualManagement: item.manualManagement.filter(
            x => !manualManagement.some(y => y.customer === x.customer && y.amount === x.amount)
          ),
          clientItems: item.clientItems.filter(
            x => !clientItems.some(y => y.CO_DOCUMENT_NUMBER === x.CO_DOCUMENT_NUMBER)
          )
        }))
        .filter(x => x.manualManagement.length > 0 || x.clientItems.length > 0)
    ]
  };
};

const modifyItemsSelection = (state, { payload: { itemObject } }) => {
  const { clientItems } = state;

  const itemIndex = R.findIndex(element => {
    const {
      QT_POSITION,
      ID_PERIOD,
      CO_PERIOD_VARIANT,
      CO_SOCIETY,
      ID_CUSTOMER,
      CO_DOCUMENT_NUMBER,
      QT_EXPIRATION_POSITION
    } = itemObject;
    return (
      // Just in case they are not the same type
      // eslint-disable-next-line eqeqeq
      QT_POSITION == element.QT_POSITION &&
      // eslint-disable-next-line eqeqeq
      ID_PERIOD == element.ID_PERIOD &&
      // eslint-disable-next-line eqeqeq
      CO_PERIOD_VARIANT == element.CO_PERIOD_VARIANT &&
      // eslint-disable-next-line eqeqeq
      CO_SOCIETY == element.CO_SOCIETY &&
      // eslint-disable-next-line eqeqeq
      ID_CUSTOMER == element.ID_CUSTOMER &&
      // eslint-disable-next-line eqeqeq
      CO_DOCUMENT_NUMBER == element.CO_DOCUMENT_NUMBER &&
      // eslint-disable-next-line eqeqeq
      QT_EXPIRATION_POSITION == element.QT_EXPIRATION_POSITION
    );
  })(clientItems);

  if (itemIndex === -1) return { ...state, loading: false, error: true };

  clientItems[itemIndex] = {
    ...clientItems[itemIndex],
    selected: !clientItems[itemIndex].selected
  };

  return { ...state, clientItems, modified: true };
};

const addManual = (state, { payload: { paymentObject } }) => ({
  ...state,
  manualManagement: [...state.manualManagement, paymentObject],
  modified: true
});

const editManual = (state, { payload: { paymentObject, index } }) => {
  const manualManagement = state.manualManagement.slice();
  manualManagement.splice(index, 1, { ...paymentObject });
  return {
    ...state,
    manualManagement,
    modified: true
  };
};

const removeManual = (state, { payload: index }) => {
  const manualManagement = state.manualManagement.slice();
  manualManagement.splice(index, 1);
  return {
    ...state,
    manualManagement,
    modified: true
  };
};

const setSelectedProposal = (state, action) => ({
  ...state,
  selectedProposal: action.payload,
  modified: false
});
const ACTION_HANDLERS = {
  [DETAIL.GET_PROPOSALS]: setLoading,
  [DETAIL.GET_PROPOSALS_SUCCESS]: getProposalsSuccess,
  [DETAIL.GET_PROPOSALS_ERROR]: setErrors,
  [DETAIL.SEARCH_TRANSFER_SUCCESS]: searchTransferSuccess,
  [DETAIL.SEARCH_TRANSFER_ERROR]: setErrors,
  [DETAIL.GET_ITEMS]: setLoading,
  [DETAIL.GET_ITEMS_SUCCESS]: getItemsSuccess,
  [DETAIL.GET_ITEMS_ERROR]: setErrors,
  [DETAIL.MODIFY_ITEMS_SELECTION]: modifyItemsSelection,
  [DETAIL.SEARCH_TRANSFER]: setLoading,
  [DETAIL.ADD_MANUAL]: addManual,
  [DETAIL.EDIT_MANUAL]: editManual,
  [DETAIL.REMOVE_MANUAL]: removeManual,
  [DETAIL.SET_SELECTED_PROPOSAL]: setSelectedProposal,
  [DETAIL.ADD_TRANSFER_TO_PROPSAL]: addTransfesrToProposals,
  [DETAIL.REMOVE_TRANSFER_TO_PROPSAL]: removeTransfesrToProposals
};

export default (state = defaultState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};
